import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["manual_checkbox", "currency_radio", "currency_radio_group", "rate_input", "manual_rates", "currency_label"]

  connect() {
    // this.updateRateInputsState()
    this.setupCurrencyRadioListeners()
  }

  setupCurrencyRadioListeners() {
    this.currency_radioTargets.forEach(radio => {
      radio.addEventListener('change', this.onCurrencyChange.bind(this))
    })
  }

  onCurrencyChange(event) {
    const selectedCurrency = event.target.value
    // Update the currency label in the amount field
    if (this.hasCurrency_labelTarget) {
      this.currency_labelTarget.textContent = selectedCurrency
    }
  }

  onManualChange(event) {
    this.updateRateInputsState()
  }

  updateRateInputsState() {
    const isManual = this.manual_checkboxTarget.checked
    this.rate_inputTargets.forEach(input => {
      input.disabled = !isManual
      if (isManual) {
        input.required = true
      } else {
        input.required = false
      }
    })
  }

  disableAllRateInputs() {
    this.rate_inputTargets.forEach(input => {
      input.disabled = true
      input.required = false
    })
  }
}